export function upgradeMdl() {
  if (!(typeof(componentHandler) === 'undefined')){
    // eslint-disable-next-line no-undef
    componentHandler.upgradeAllRegistered();
  }
}
